import { render, staticRenderFns } from "./UserLikesVirtualItem.vue?vue&type=template&id=af12041a&scoped=true"
import script from "./UserLikesVirtualItem.vue?vue&type=script&lang=js"
export * from "./UserLikesVirtualItem.vue?vue&type=script&lang=js"
import style0 from "./UserLikesVirtualItem.vue?vue&type=style&index=0&id=af12041a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12041a",
  null
  
)

export default component.exports